import { handleToastError } from './handleToastError';
import { handleToastSuccess } from './handleToastSuccess';
import { QuizToastActions } from '.';

const isError = (error: unknown) => {
  return error && error instanceof Error;
};

export const apiToaster = (
  items: (string | number)[],
  action: QuizToastActions,
  error?: Error | unknown
) => {
  if (isError(error)) {
    return handleToastError(action, error);
  }

  return handleToastSuccess(items, action);
};
